/* ———————————————————————————————————————————————————————————————————————————————— 
Usage: 
se pasa el elemento que queremos observar: loadVideoLazy('.video-container'); 
cuando el x% del elemento está visible  : threshold: 0.1 (10%)
se itera por cada video que tenga clase "video-lazy"
se le añade  la url a src
se de a play
deja de observar
———————————————————————————————————————————————————————————————————————————————— */
function loadVideoLazy(trigger){ 
  const containerTrigger = document.querySelector(trigger); 
  const videos = containerTrigger.querySelectorAll('.video-lazy');  
  
  const observer = new IntersectionObserver((entries, observer) => {    
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // console.log("Container is in view, loading videos");        
        loadVideoLazyDevice(trigger)        
        observer.unobserve(entry.target);
      } 
    });
  }, {
    threshold: 0
  });

  observer.observe(containerTrigger);
}


/* ———————————————————————————————————————————————————————————————————————————————— 
DEVICE 
Usage: 
loadVideoLazyDevice(`.png-{{ section.id }}`)
se usa para que se descargue solo el video relacionado al device en uso  
———————————————————————————————————————————————————————————————————————————————— */
function loadVideoLazyDevice(trigger){

  const containerTrigger = document.querySelector(trigger); 
  
  const mobileVideo = containerTrigger.querySelector('.hideOnDesktop');
  const desktopVideo = containerTrigger.querySelector('.hideOnMobile');

  function updateVideoSource() {
    if (window.innerWidth < 768) {
      
      const mobileSource = mobileVideo.querySelector('source');
      if (!mobileSource.getAttribute('src')) {      
        mobileSource.src = mobileSource.getAttribute('data-src');
        mobileVideo.load(); 
        mobileVideo.play(); 
      }
    } else {
      const desktopSource = desktopVideo.querySelector('source');
      if (!desktopSource.getAttribute('src')) {   
        desktopSource.src = desktopSource.getAttribute('data-src');
        desktopVideo.load();  
        desktopVideo.play();  
      }
    }
  }

  // Run on load
  updateVideoSource();

  // Run on resize
  window.addEventListener('resize', updateVideoSource);
}
 
 
